import { render, staticRenderFns } from "./v_Creator.vue?vue&type=template&id=0a971efa&scoped=true&"
import script from "./v_Creator.vue?vue&type=script&lang=js&"
export * from "./v_Creator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a971efa",
  null
  
)

export default component.exports